import { useEffect } from 'react';
import { Button } from '../ui/Button/Button';
import { SHORTCUT_HELP } from './shortcuts';

interface KeyboardShortcutsOverlayProps {
  open: boolean;
  onClose: () => void;
}

export function KeyboardShortcutsOverlay({
  open,
  onClose
}: KeyboardShortcutsOverlayProps) {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;

      event.preventDefault();
      onClose();
    };

    window.addEventListener('keydown', handleKeyDown, true);

    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="shortcut-overlay" role="presentation" onMouseDown={onClose}>
      <section
        className="shortcut-overlay__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shortcut-overlay-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="shortcut-overlay__header">
          <div>
            <h2 id="shortcut-overlay-title">Keyboard shortcuts</h2>
            <p>Press <kbd>/</kbd> anywhere outside an input to open the command bar.</p>
          </div>

          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </header>

        <div className="shortcut-overlay__list">
          {SHORTCUT_HELP.map((item) => (
            <div key={item.command} className="shortcut-overlay__row">
              <code>{item.command}</code>
              <span>{item.description}</span>
            </div>
          ))}
        </div>

        <footer className="shortcut-overlay__footer">
          <span><kbd>Enter</kbd> runs the command</span>
          <span><kbd>Esc</kbd> closes the command bar</span>
        </footer>
      </section>
    </div>
  );
}